import React from "react";
import { BsArrowUp } from "react-icons/bs";

function ScrollTop(props) {
  //   function handleBackClick() {
  //     titleRef.current.scrollIntoView({ behavior: "smooth" });
  //   }
  return (
    <div className="topBtn-frame" onClick={props.handleBackClick}>
      <div className="topBtn">
        <BsArrowUp />
      </div>
      <div className="topbtn-bg"></div>
    </div>
  );
}

export default ScrollTop;
